import { render, staticRenderFns } from "./cartTrapezSOR.vue?vue&type=template&id=47ed4f02&"
import script from "./cartTrapezSOR.vue?vue&type=script&lang=js&"
export * from "./cartTrapezSOR.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports